class KullaniciListesiAramaKriterleri {
    kimlikId: number = null;
    adi: string = "";
    soyadi: string = "";
    kodu: string = "";
    kimlikNo: string = "";
};
export default KullaniciListesiAramaKriterleri;